// DO NOT EDIT -- generated from fs/services/grant/access.proto

import * as flags from '../../shared/flags';
import * as protobuf from '../../../google/protobuf';

export namespace AccessService {

  export const AssignMappingsEndpoint = "/grpc/grant.AccessService/AssignMappings";
  /** Bulk mapping assignment for both group members and access mappings. */
  export function AssignMappings(sender: (req: AssignMappingsRequest, endpoint: string) => Promise<{}>, req: AssignMappingsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, AssignMappingsEndpoint),
      endpoint: AssignMappingsEndpoint
    };
  }

  export const ListAccessEndpoint = "/grpc/grant.AccessService/ListAccess";
  /** Lists access for a user/group. */
  export function ListAccess(sender: (req: ListAccessRequest, endpoint: string) => Promise<ListAccessResponse>, req: ListAccessRequest): { promise: () => Promise<ListAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListAccessEndpoint),
      endpoint: ListAccessEndpoint
    };
  }

  export const ListAccessForSpaceEndpoint = "/grpc/grant.AccessService/ListAccessForSpace";
  /** Lists all of the users and groups that have been given access to a specific space */
  export function ListAccessForSpace(sender: (req: ListAccessForSpaceRequest, endpoint: string) => Promise<ListAccessForSpaceResponse>, req: ListAccessForSpaceRequest): { promise: () => Promise<ListAccessForSpaceResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListAccessForSpaceEndpoint),
      endpoint: ListAccessForSpaceEndpoint
    };
  }

  export const BulkListAccessForSpacesEndpoint = "/grpc/grant.AccessService/BulkListAccessForSpaces";
  /** Lists all of the users and groups that have been given access to a specific space */
  export function BulkListAccessForSpaces(sender: (req: BulkListAccessForSpacesRequest, endpoint: string) => Promise<BulkListAccessForSpacesResponse>, req: BulkListAccessForSpacesRequest): { promise: () => Promise<BulkListAccessForSpacesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BulkListAccessForSpacesEndpoint),
      endpoint: BulkListAccessForSpacesEndpoint
    };
  }

  export const CheckAccessEndpoint = "/grpc/grant.AccessService/CheckAccess";
  /** Checks the access for a given subject. */
  export function CheckAccess(sender: (req: CheckAccessRequest, endpoint: string) => Promise<CheckAccessResponse>, req: CheckAccessRequest): { promise: () => Promise<CheckAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CheckAccessEndpoint),
      endpoint: CheckAccessEndpoint
    };
  }

  export const ListGroupMembershipsEndpoint = "/grpc/grant.AccessService/ListGroupMemberships";
  /** Lists group memberships for an org */
  export function ListGroupMemberships(sender: (req: ListGroupMembershipsRequest, endpoint: string) => Promise<ListGroupMembershipsResponse>, req: ListGroupMembershipsRequest): { promise: () => Promise<ListGroupMembershipsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListGroupMembershipsEndpoint),
      endpoint: ListGroupMembershipsEndpoint
    };
  }

  export const GetChangesEndpoint = "/grpc/grant.AccessService/GetChanges";
  /** Gets all tuple changes since the last fetch given the continuation token. */
  export function GetChanges(sender: (req: GetChangesRequest, endpoint: string) => Promise<GetChangesResponse>, req: GetChangesRequest): { promise: () => Promise<GetChangesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetChangesEndpoint),
      endpoint: GetChangesEndpoint
    };
  }

  export const SyncRelationsEndpoint = "/grpc/grant.AccessService/SyncRelations";
  /**
   * Syncs relations owned by other systems into the access mappings for required
   * authorization model data.
   */
  export function SyncRelations(sender: (req: SyncRelationsRequest, endpoint: string) => Promise<{}>, req: SyncRelationsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, SyncRelationsEndpoint),
      endpoint: SyncRelationsEndpoint
    };
  }

  export const UpdateSpaceAccessEndpoint = "/grpc/grant.AccessService/UpdateSpaceAccess";
  /** Updates access for a space, including all access level, group access, and user access. */
  export function UpdateSpaceAccess(sender: (req: UpdateSpaceAccessRequest, endpoint: string) => Promise<{}>, req: UpdateSpaceAccessRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateSpaceAccessEndpoint),
      endpoint: UpdateSpaceAccessEndpoint
    };
  }
}

export namespace AccessServicePublic {

  export const AssignMappingsEndpoint = "/grpc/grant.AccessServicePublic/AssignMappings";
  export function AssignMappings(sender: (req: AssignMappingsRequest, endpoint: string) => Promise<{}>, req: AssignMappingsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, AssignMappingsEndpoint),
      endpoint: AssignMappingsEndpoint
    };
  }

  export const ListAccessForSpaceEndpoint = "/grpc/grant.AccessServicePublic/ListAccessForSpace";
  /** Lists all of the users and groups that have been given access to a specific space */
  export function ListAccessForSpace(sender: (req: ListAccessForSpaceRequest, endpoint: string) => Promise<ListAccessForSpaceResponse>, req: ListAccessForSpaceRequest): { promise: () => Promise<ListAccessForSpaceResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListAccessForSpaceEndpoint),
      endpoint: ListAccessForSpaceEndpoint
    };
  }

  export const UpdateSpaceAccessEndpoint = "/grpc/grant.AccessServicePublic/UpdateSpaceAccess";
  /** Updates access for a space, including all access level, group access, and user access. */
  export function UpdateSpaceAccess(sender: (req: UpdateSpaceAccessRequest, endpoint: string) => Promise<{}>, req: UpdateSpaceAccessRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateSpaceAccessEndpoint),
      endpoint: UpdateSpaceAccessEndpoint
    };
  }

  export const UpdateGroupMembershipsEndpoint = "/grpc/grant.AccessServicePublic/UpdateGroupMemberships";
  /** Update group memberships */
  export function UpdateGroupMemberships(sender: (req: UpdateGroupMembershipsRequest, endpoint: string) => Promise<{}>, req: UpdateGroupMembershipsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateGroupMembershipsEndpoint),
      endpoint: UpdateGroupMembershipsEndpoint
    };
  }
}

export interface GroupMembership {
  groupId: string;
  email: string;
}

export interface AccessMapping {
  groupId?: string;
  email?: string;
  all?: boolean;
  /** The access being granted/mapped. */
  access: Access | null;
}

export namespace AccessMapping {
  /** The subject that receives the access. */
  export enum subject {
    groupId = 1,
    email = 2,
    all = 3
  }

  /** The subject that receives the access. */
  export function subject_oneof(m: AccessMapping): { opt: subject.all, val: boolean } | { opt: subject.email, val: string } | { opt: subject.groupId, val: string } | null {
    if (m.groupId != null) { return { opt: subject.groupId, val: m.groupId } }
    if (m.email != null) { return { opt: subject.email, val: m.email } }
    if (m.all != null) { return { opt: subject.all, val: m.all } }
    return null;
  }
}

export interface Access {
  /** Grants access to an application feature/permission. */
  applicationPermission?: Access.ApplicationPermission | null;
  /** Grants access to a space. */
  space?: Access.Space | null;
  /** Grants acccess to a dx object. */
  dxObject?: Access.DxObject | null;
  /** Grants access to a data classification. */
  dataClassification?: Access.DataClassification | null;
}

export namespace Access {
  export enum access {
    /** Grants access to an application feature/permission. */
    applicationPermission = 1,
    /** Grants access to a space. */
    space = 2,
    /** Grants acccess to a dx object. */
    dxObject = 3,
    /** Grants access to a data classification. */
    dataClassification = 4
  }

  export function access_oneof(m: Access): { opt: access.applicationPermission, val: Access.ApplicationPermission } | { opt: access.dataClassification, val: Access.DataClassification } | { opt: access.dxObject, val: Access.DxObject } | { opt: access.space, val: Access.Space } | null {
    if (m.applicationPermission != null) { return { opt: access.applicationPermission, val: m.applicationPermission } }
    if (m.space != null) { return { opt: access.space, val: m.space } }
    if (m.dxObject != null) { return { opt: access.dxObject, val: m.dxObject } }
    if (m.dataClassification != null) { return { opt: access.dataClassification, val: m.dataClassification } }
    return null;
  }

  export interface ApplicationPermission {
    /**
     * The application permission to be granted.
     * Only "Perm" prefixed flags flags are supported.
     * Some permissions may imply additional permissions automatically
     * to ensure correct behavior.
     */
    permission: flags.Flag;
  }

  export interface Space {
    id: string;
    action: ResourceAccessAction;
  }

  export interface DxObject {
    dxObjectId: string;
    dxObjectType: Access.DxObject.Type;
    action: ResourceAccessAction;
  }

  export namespace DxObject {
    export enum Type {
      INVALID = 0,
      METRIC = 1,
      FUNNEL = 2,
      RETENTION = 3,
      SEGMENT = 5,
      DASHBOARD = 6,
      HEATMAP = 7,
      JOURNEY = 8,
      DATA_TABLE = 16
    }
  }

  export interface DataClassification {
    classificationType: Access.DataClassification.Type;
    action: DataAccessAction;
  }

  export namespace DataClassification {
    export enum Type {
      UNSPECIFIED = 0,
      PII = 1,
      FINANCIAL = 2,
      RESTRICTED = 3,
      UNRESTRICTED = 4
    }
  }
}

/** Access actions for resources that can be used when custom actions are not required. */
export enum ResourceAccessAction {
  ACTION_INVALID = 0,
  ACTION_READ = 1,
  ACTION_WRITE = 2,
  ACTION_DELETE = 3
}

/** Access actions for data classifications. */
export enum DataAccessAction {
  DATA_ACTION_INVALID = 0,
  DATA_ACTION_READ = 1
}

export interface AssignMappingsRequest {
  orgId: string;
  unassignGroups: GroupMembership[];
  assignGroups: GroupMembership[];
  unassignAccess: AccessMapping[];
  assignAccess: AccessMapping[];
}

export interface ListAccessRequest {
  orgId: string;
  groupId?: string;
  email?: string;
  /** if non empty, result only includes specified */
  includes: ListAccessRequest.Include[];
  /** if true, only directly granted access is returned */
  directOnly: boolean;
  /** if set, only returns access with this action type */
  filterAction: ResourceAccessAction;
}

export namespace ListAccessRequest {
  export enum subject {
    groupId = 2,
    email = 3
  }

  export function subject_oneof(m: ListAccessRequest): { opt: subject.email, val: string } | { opt: subject.groupId, val: string } | null {
    if (m.groupId != null) { return { opt: subject.groupId, val: m.groupId } }
    if (m.email != null) { return { opt: subject.email, val: m.email } }
    return null;
  }

  export enum Include {
    INCLUDE_INVALID = 0,
    INCLUDE_GROUPS = 1,
    INCLUDE_APPLICATION_PERMISSIONS = 2,
    INCLUDE_SPACES = 3,
    INCLUDE_DX_OBJECTS = 4,
    INCLUDE_DATA_CLASSIFICATIONS = 5
  }
}

export interface ListAccessResponse {
  /** All of the groups that the subject has access to (currently only will have results for email subjects) */
  groupIds: string[];
  /** All access (direct or through groups) */
  accesses: Access[];
}

export interface ListAccessForSpaceRequest {
  orgId: string;
  spaceId: string;
}

export interface ListAccessForSpaceResponse {
  accesses: ListAccessForSpaceResponse.SpaceAccess[];
  allAccess: ResourceAccessAction;
}

export namespace ListAccessForSpaceResponse {
  export enum AccessLevel {
    INVALID = 0,
    OWNER = 1,
    EDITOR = 2,
    READER = 3
  }

  export interface Subject {
    groupId?: string;
    email?: string;
  }

  export namespace Subject {
    export enum subject {
      groupId = 1,
      email = 2
    }

    export function subject_oneof(m: Subject): { opt: subject.email, val: string } | { opt: subject.groupId, val: string } | null {
      if (m.groupId != null) { return { opt: subject.groupId, val: m.groupId } }
      if (m.email != null) { return { opt: subject.email, val: m.email } }
      return null;
    }
  }

  export interface SpaceAccess {
    subject: ListAccessForSpaceResponse.Subject | null;
    accessLevel: ListAccessForSpaceResponse.AccessLevel;
  }
}

export interface BulkListAccessForSpacesRequest {
  orgId: string;
  spaceIds: string[];
}

export interface BulkListAccessForSpacesResponse {
  spacesAccess: BulkListAccessForSpacesResponse.SpaceAccesses[];
}

export namespace BulkListAccessForSpacesResponse {
  export interface SpaceAccesses {
    spaceId: string;
    accessInfo: ListAccessForSpaceResponse | null;
  }
}

export interface CheckAccessRequest {
  orgId: string;
  /** The user email for which access is being checked. */
  email: string;
  /** The access to check. */
  accesses: Access[];
}

export interface CheckAccessResponse {
  /** Indicates whether the subject had all of the access requested. */
  ok: boolean;
  /** Indicates any access missing if ok = false. */
  missing: Access[];
}

export interface ListGroupMembershipsRequest {
  orgId: string;
  groupId?: string;
  email?: string;
}

export namespace ListGroupMembershipsRequest {
  /** these are both optional; if unset, return all for that org */
  export enum filter {
    groupId = 2,
    email = 3
  }

  /** these are both optional; if unset, return all for that org */
  export function filter_oneof(m: ListGroupMembershipsRequest): { opt: filter.email, val: string } | { opt: filter.groupId, val: string } | null {
    if (m.groupId != null) { return { opt: filter.groupId, val: m.groupId } }
    if (m.email != null) { return { opt: filter.email, val: m.email } }
    return null;
  }
}

export interface ListGroupMembershipsResponse {
  memberships: GroupMembership[];
}

export interface GetChangesRequest {
  /**
   * Page size for the number of changes to return.
   * Note: This is best effort. Given there are many changes behind the scenes that do not apply to this API,
   *       results will not always be full pages and could even be empty.
   */
  pageSize: number;
  continuationToken?: string;
  time?: protobuf.timestamp | null;
}

export namespace GetChangesRequest {
  export enum since {
    continuationToken = 2,
    time = 3
  }

  export function since_oneof(m: GetChangesRequest): { opt: since.continuationToken, val: string } | { opt: since.time, val: protobuf.timestamp } | null {
    if (m.continuationToken != null) { return { opt: since.continuationToken, val: m.continuationToken } }
    if (m.time != null) { return { opt: since.time, val: m.time } }
    return null;
  }
}

export interface GetChangesResponse {
  /**
   * The changes that have occurred since the last fetch.
   * Note: These are direct mappings across all orgs that were either written or deleted.
   *       The page size is best effort and may not result in full changes here.
   *       Use continuation token to determine if there are more results.
   */
  changes: GetChangesResponse.Change[];
  /**
   * The continuation token to use for the next fetch.
   * If the same as the last token, there are no more changes at the moment.
   * Future changes will be available in the next fetch.
   */
  continuationToken: string;
}

export namespace GetChangesResponse {
  export interface Change {
    orgId: string;
    mapping: AccessMapping | null;
    operation: GetChangesResponse.Operation;
    time: protobuf.timestamp | null;
  }

  export enum Operation {
    OPERATION_INVALID = 0,
    OPERATION_WRITE = 1,
    OPERATION_DELETE = 2
  }
}

export interface SyncRelationsRequest {
  orgId: string;
  spaces: SyncRelationsRequest.Space[];
  dxObjects: SyncRelationsRequest.DxObject[];
  backfill: boolean;
}

export namespace SyncRelationsRequest {
  export interface Space {
    id: string;
    owningUserEmails: string[];
    allAccess: ResourceAccessAction;
  }

  export interface DxObject {
    dxObjectId: string;
    dxObjectType: Access.DxObject.Type;
    owningSpaceId: string;
    owningUserEmails: string[];
    referencedInSpaces: string[];
  }
}

export interface UpdateSpaceAccessRequest {
  orgId: string;
  spaceId: string;
  allAccess: ResourceAccessAction;
  addGroups: GroupAccess[];
  removeGroups: GroupAccess[];
  addUsers: UserAccess[];
  removeUsers: UserAccess[];
}

export interface UpdateGroupMembershipsRequest {
  orgId: string;
  addGroupMemberships: GroupMembership[];
  removeGroupMemberships: GroupMembership[];
}

export interface GroupAccess {
  groupId: string;
  accessLevel: ResourceAccessAction;
}

export interface UserAccess {
  email: string;
  accessLevel: ResourceAccessAction;
}
